import { Badge } from '@/shared/components/Badge'

export function RoleBadge({ role }: { role: string }) {
  return <Badge variant="accent">{role}</Badge>
}
